import { render, staticRenderFns } from "./crm-create.vue?vue&type=template&id=6ae9d1f2&"
import script from "./crm-create.vue?vue&type=script&lang=js&"
export * from "./crm-create.vue?vue&type=script&lang=js&"
import style0 from "./crm-create.vue?vue&type=style&index=0&id=6ae9d1f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports